"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDetectOutsideClick = void 0;
const react_1 = __importDefault(require("react"));
/**
 * Detect outside click events.
 */
function useDetectOutsideClick({ onClick, ref, }) {
    react_1.default.useEffect(() => {
        function handleClickOutside(event) {
            if (ref.current &&
                event.target instanceof Element &&
                !ref.current.contains(event.target)) {
                onClick(event);
            }
        }
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [ref, onClick]);
}
exports.useDetectOutsideClick = useDetectOutsideClick;
